<template>
  <v-card>
    <v-card-title class="text-h5">
      <span v-if="nouveau">{{ $t("user.dialog.title_new") }} </span>
      <span v-else>{{ $t("user.dialog.title_edit") }} </span>
      <span v-if="form.is_dr">&nbsp;DR</span>
      <span v-else>&nbsp;Labo</span>
    </v-card-title>
    <v-card-text>
      <v-form ref="form">
        <v-checkbox v-model="form.is_dr" :label="$t('user.isDr')" />
        <v-checkbox
          v-if="!nouveau"
          v-model="form.is_active"
          :value="value.is_active"
          :label="$t('user.is_active')"
        />
        <v-text-field
          v-model="form.first_name"
          :value="value.first_name"
          :label="$t('user.prenom')"
        />
        <v-text-field
          v-model="form.last_name"
          :value="value.last_name"
          :label="$t('user.nom')"
        />
        <v-text-field
          v-model="form.email"
          :value="value.email"
          :label="$t('user.email')"
          :rules="[validrules.email(form.email)]"
          @input="form.username = form.email ? form.email.split('@')[0] : ''"
        />
        <v-text-field
          v-model="form.second_mail"
          :value="value.second_mail"
          :label="$t('user.secondMail')"
        />
        <v-autocomplete
          v-model="form.dr"
          :value="value.dr"
          :items="drs"
          item-value="id"
          item-text="code_safir"
          multiple
          chips
          deletable-chips
          clearable
          :label="$t('user.dr')"
        />
        <template v-if="form.is_dr">
          <v-checkbox
            v-if="user.is_superuser"
            v-model="form.is_create_user"
            :value="value.is_create_user"
            :label="$t('user.isCreateUser')"
          />
          <v-checkbox
            v-model="form.is_generate_facture"
            :value="value.is_generate_facture"
            :label="$t('user.isGenerateFacture')"
          />
          <v-checkbox
            v-model="form.is_cancel_ligne"
            :value="value.is_cancel_ligne"
            :label="$t('user.isCancelLigne')"
          />
          <v-checkbox
            v-model="form.is_carte"
            :value="value.is_carte"
            :label="$t('user.isCarte')"
          />
        </template>
        <v-autocomplete
          v-model="form.sb"
          :value="value.sb"
          :items="structs"
          item-value="id"
          item-text="libelle"
          multiple
          deletable-chips
          chips
          clearable
          :label="$t('user.sb')"
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="color_danger" @click="closeDialog">
        <v-icon left dark> mdi-close</v-icon>
        {{ $t("btn.close") }}
      </v-btn>
      <v-spacer />
      <v-btn :disabled="disabled()" color="color_action" @click="saveUser()">
        <v-icon left dark> mdi-send</v-icon>
        {{ $t("btn.submit") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { structureMixin } from "@/mixins/structure";
import { drMixin } from "@/mixins/dr";
import { validrules } from "@/common/validrules";
import { userMixin } from "@/mixins/user";

export default {
  name: "DialogUser",
  mixins: [structureMixin, drMixin, userMixin],
  props: {
    title: {
      type: String,
      required: true,
    },
    aleat: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    nouveau: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      validrules: validrules,
      form: {},
    };
  },
  methods: {
    saveUser($evt) {
      this.$emit("input", this.form);
      this.$emit("saveUser", $evt, this.form);
    },
    closeDialog($evt) {
      this.$emit("closeDialog", $evt);
    },
    disabled() {
      return (
        !(
          validrules.requiredBool(this.form.last_name) &&
          validrules.requiredBool(this.form.email) &&
          validrules.requiredSelectBool(this.form.dr)
        ) ||
        (!this.form.is_dr && !validrules.requiredSelectBool(this.form.sb))
      );
    },
  },
  watch: {
    value() {
      this.form = { ...this.value };
    },
  },
  created() {
    this.form = { ...this.value };
  },
};
</script>

<style scoped></style>
